import { isAdvertisersDemoAccount } from "./advertisersDemo";

export const DEMO_BRAND_LEARNED_INSIGHTS = {
  lastIngest: {
    fingerprint: "1789362000000|1789793999999",
    source: "weekly",
    time: 1789766438904,
  },
  lastSeenAt: 1789770257104,
  negative: [
    {
      i18n: {
        en: {
          description:
            "Do not lead with claims such as “215 ventas en cinco días” or “de 2x a 5x” unless they are supported by a verifiable case. Prioritize demonstrable benefits and mechanisms, and use social proof only when it is specific and credible.",
          title: "unsubstantiated quantified promises",
        },
        es: {
          description:
            "No uses afirmaciones como “215 ventas en cinco días” o “de 2x a 5x” como hook principal si no están respaldadas por un caso verificable. Prioriza beneficios y mecanismos que puedan demostrarse, y presenta la prueba social solo cuando sea concreta y creíble.",
          title: "Promesas cuantificadas sin prueba demostrable",
        },
        pt: {
          description:
            "Não use afirmações como “215 ventas en cinco días” ou “de 2x a 5x” como gancho principal se não estiverem apoiadas por um caso verificável. Priorize benefícios e mecanismos que possam ser demonstrados, e apresente a prova social apenas quando for concreta e confiável.",
          title: "Promessas quantificadas sem prova demonstrável",
        },
      },
      topicKey: "value-prop.credible-performance-proof",
    },
    {
      addedAt: 1789766438904,
      i18n: {
        en: {
          description:
            "Do not combine automation, reporting, control, and growth in the same creative set or scatter the message across multiple startup-focused headlines. Center each message on one problem—such as detecting budget leaks or executing without hiring a CMO—and one verifiable promise with a clear next step.",
          title: "Too many benefits in one message",
        },
        es: {
          description:
            "No combines automatización, reporting, control y growth en una sola tanda ni mezcles varios titulares para startups. Centra cada mensaje en un problema —como detectar fugas de presupuesto o ejecutar sin contratar un CMO— y una promesa verificable, con un siguiente paso claro.",
          title: "Demasiados beneficios en un mismo mensaje",
        },
        pt: {
          description:
            "Não combine automação, reporting, controle e growth em um único conjunto nem misture vários títulos para startups. Centre cada mensagem em um problema —como detectar vazamentos de orçamento ou executar sem contratar um CMO— e uma promessa verificável, com um próximo passo claro.",
          title: "Benefícios demais na mesma mensagem",
        },
      },
      topicKey: "copy.single-problem-single-promise",
    },
  ],
  positive: [
    {
      i18n: {
        en: {
          description:
            "Open with specific tensions such as “¿Tu CAC está subiendo?”, “¿Dónde se fuga tu presupuesto?” and “¿Tus anuncios dejan de vender después de unas semanas?”. Then connect the problem to a clear Adle mechanism and a demo CTA, keeping product capabilities subordinate to the pain.",
          title: "Hooks built around a concrete pain",
        },
        es: {
          description:
            "Abre con tensiones específicas como “¿Tu CAC está subiendo?”, “¿Dónde se fuga tu presupuesto?” y “¿Tus anuncios dejan de vender después de unas semanas?”. Después, conecta el problema con un mecanismo claro de Adle y un CTA de demo, dejando las capacidades del producto como respuesta al dolor.",
          title: "Hooks basados en un dolor concreto",
        },
        pt: {
          description:
            "Abra com tensões específicas como “¿Tu CAC está subiendo?”, “¿Dónde se fuga tu presupuesto?” e “¿Tus anuncios dejan de vender después de unas semanas?”. Depois, conecte o problema a um mecanismo claro da Adle e a um CTA de demo, deixando as capacidades do produto como resposta à dor.",
          title: "Ganchos baseados em uma dor concreta",
        },
      },
      topicKey: "angle.concrete-paid-media-pain",
    },
    {
      i18n: {
        en: {
          description:
            "When the pain is designing blindly or producing too slowly, show a demonstrable mechanism—ad variants and rapid testing—and connect it to an outcome such as more leads or better advertising return. The feature should explain how the benefit is achieved, not replace it.",
          title: "Validated mechanism to business outcome",
        },
        es: {
          description:
            "Cuando el dolor sea diseñar a ciegas o producir demasiado lento, muestra un mecanismo demostrable —variantes de anuncios y prueba rápida— y conéctalo con un resultado como más clientes potenciales o mejor retorno publicitario. La funcionalidad debe explicar cómo se alcanza el beneficio, no sustituirlo.",
          title: "Mecanismo validado hacia resultado comercial",
        },
        pt: {
          description:
            "Quando a dor for desenhar no escuro ou produzir devagar demais, mostre um mecanismo demonstrável —variantes de anúncios e teste rápido— e conecte-o a um resultado como mais leads ou melhor retorno publicitário. A funcionalidade deve explicar como o benefício é alcançado, não substituí-lo.",
          title: "Mecanismo validado até o resultado comercial",
        },
      },
      topicKey: "angle.pain-to-immediate-action",
    },
  ],
  updatedTime: 1789766438904,
};

export const getDemoBrandLearnedInsights = () =>
  structuredClone(DEMO_BRAND_LEARNED_INSIGHTS);

export const shouldUseDemoBrandLearnedInsights = ({
  advertiserID,
  agencyID,
  shopID,
} = {}) => isAdvertisersDemoAccount({ advertiserID, agencyID, shopID });
